document.addEventListener('alpine:init', () => {
    Alpine.data('LargeBanner', () => ({
        show: false,
        components: [],
        init() {
            this.show = true;
            this.components = document.querySelectorAll('.Pegasus__Container');
        },
        scrollToNextComponent() {
            const currentScrollPos = window.scrollY;
            let nextComponent = null;
            
            for (let i = 0; i < this.components.length; i++) {
                const componentTop = this.components[i].offsetTop;
                
                if (componentTop > currentScrollPos) {
                    nextComponent = this.components[i];
                    break;
                }
            }
            
            if (nextComponent) {
                pegasus.scroll(nextComponent, -100, "scrollTo");
            }
        }
    }));
});
